// A rematch is offered to a player only while their game has just finished (SPEC §6.1): on the
// game's page from the moment it finished until they leave it. The browser remembers the games
// whose offer is over, per account, so that opening an old game again doesn't offer it. The list
// keeps the most recent entries only; losing it just offers a rematch once more.
const KEY = 'slowgo.rematch-over';
const LIMIT = 200;

let memory = [];

const entry = (userId, gameId) => `${userId}:${gameId}`;

function read() {
  try {
    const kept = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(kept) ? kept : memory;
  } catch (e) { return memory; }
}

function write(list) {
  memory = list.slice(-LIMIT);
  try { localStorage.setItem(KEY, JSON.stringify(memory)); } catch (e) { /* unavailable storage */ }
}

// over tells whether this account's rematch offer for the game is already over.
export function over(userId, gameId) {
  if (!userId || !gameId) return true;
  return read().includes(entry(userId, gameId));
}

// endOffer records that the offer is over: the player has left the finished game's page.
export function endOffer(userId, gameId) {
  if (!userId || !gameId) return;
  const e = entry(userId, gameId);
  const list = read().filter(i => i !== e);
  list.push(e);
  write(list);
}

export default { over, endOffer };
